<main class="container-fluid">
    <article class="gutter-row flex flex-col justify-center min-h-screen background-container" id="aboutUs">
        <div class="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
            <div class="text-start mb-8">
                <div class="text-primary text-2xl font-semibold mb-6 flex items-center">
                    <i nz-icon nzType="arrow-left" class="text-primary cursor-pointer mr-3 hover:text-blue-700 transition-colors" (click)="location.back()"></i>
                    <span>About Us</span>
                </div>
                <div class="space-y-6 text-gray-600 text-lg leading-relaxed">
                    <p class="first-letter:text-2xl first-letter:font-semibold first-letter:text-primary">
                        We dare to imagine a world where efficiency takes priority, where everything and
                        everyone is connected.
                    </p>
                    <p>
                        With our unique approach of keeping compliance and the end user in mind, we
                        deliver a healthy prognosis for your business helping you keep your operations
                        efficient, safe, and compliant.
                    </p>
                    <p>
                        We provide visibility and analytics that delve deep into the performance of your
                        equipment, sites, and teams.
                    </p>
                </div>
            </div>
            
            <nz-divider nzDashed class="my-8"></nz-divider>
            
            <div>
                <h2 class="text-2xl font-bold text-primary mb-6 flex items-center">
                    <i nz-icon nzType="heart" class="text-primary mr-3"></i>
                    Our Core Values
                </h2>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <!-- Make it simple -->
                    <nz-card class="bg-white border-t-4 border-primary">
                        <div class="flex flex-col">
                            <div class="flex items-center mb-3">
                                <i nz-icon nzType="bulb" class="text-primary text-xl mr-2"></i>
                                <h3 class="text-xl font-semibold text-gray-800">
                                    Make it simple
                                </h3>
                            </div>
                            <p class="text-gray-600">
                                We expect to do the work and deliver technical solutions to complex
                                problems, simply.
                            </p>
                        </div>
                    </nz-card>

                    <!-- Increase efficiency -->
                    <nz-card class="bg-white border-t-4 border-primary">
                        <div class="flex flex-col">
                            <div class="flex items-center mb-3">
                                <i nz-icon nzType="rocket" class="text-primary text-xl mr-2"></i>
                                <h3 class="text-xl font-semibold text-gray-800">
                                    Increase efficiency
                                </h3>
                            </div>
                            <p class="text-gray-600">
                                We imagine a world where everything and everyone is connected to reduce
                                inefficiencies.
                            </p>
                        </div>
                    </nz-card>

                    <!-- Relentless iteration -->
                    <nz-card class="bg-white border-t-4 border-primary">
                        <div class="flex flex-col">
                            <div class="flex items-center mb-3">
                                <i nz-icon nzType="sync" class="text-primary text-xl mr-2"></i>
                                <h3 class="text-xl font-semibold text-gray-800">
                                    Relentless iteration
                                </h3>
                            </div>
                            <p class="text-gray-600">
                                Our energy to learn new things and create solutions every day is
                                unmatched anywhere in the world.
                            </p>
                        </div>
                    </nz-card>
                </div>
            </div>
        </div>
    </article>
</main>